/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./UsernameConfirm.css";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

class UsernameConfirm extends Component {
  componentDidMount() {
    try {
      if (
        this.props.location.confirm !== null ||
        this.props.location.confirm !== undefined
      ) {
        if (!this.props.location.confirm) {
          this.props.history.push({
            pathname: "/",
          });
        }
      }
    } catch (e) {
      this.props.history.push({
        pathname: "/",
      });
    }
  }

  render() {
    const languageObj = this.props.languageObj;

    return (
      <div className="UsernameConfirm-view">
        <div className="UsernameConfirm-header">
          <div className="UsernameConfirm-logo"></div>
        </div>

        <div className="UsernameConfirm-loginContainer">
          <div className="UsernameConfirm-mailboxIcn"></div>
          <div className="UsernameConfirm-text"> {languageObj.text}</div>
          <Link to={this.props.location.nextPage}>
            <div className="UsernameConfirm-doneBtn">{languageObj.doneBtn}</div>
          </Link>
        </div>
      </div>
    );
  }
}
UsernameConfirm.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

export default UsernameConfirm;
